import { css } from 'linaria';

export const additionalInfo = css`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const additionalInfoRow = css`
  display: flex;
  column-gap: 12px;
  padding: 0;
  margin: 0;
  margin-bottom: 4px;
`;
